export function formatRelativeTime(dateString: string): string {
	const date = new Date(dateString)
	const now = new Date()
	const diffMs = now.getTime() - date.getTime()
	const diffMins = Math.floor(diffMs / 60000)
	const diffHours = Math.floor(diffMins / 60)
	const diffDays = Math.floor(diffHours / 24)

	if (diffMins < 60) return `${diffMins} мин назад`
	if (diffHours < 24) return `${diffHours} ч назад`
	if (diffDays < 7) return `${diffDays} дн назад`

	return date.toLocaleDateString("ru-RU", {
		day: "numeric",
		month: "short",
	})
}
